import { render, staticRenderFns } from "./CountryDashboardItem.vue?vue&type=template&id=3978720b&scoped=true"
import script from "./CountryDashboardItem.vue?vue&type=script&lang=js"
export * from "./CountryDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./CountryDashboardItem.vue?vue&type=style&index=0&id=3978720b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978720b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3978720b')) {
      api.createRecord('3978720b', component.options)
    } else {
      api.reload('3978720b', component.options)
    }
    module.hot.accept("./CountryDashboardItem.vue?vue&type=template&id=3978720b&scoped=true", function () {
      api.rerender('3978720b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/CountryDashboardItem.vue"
export default component.exports